module.exports = __webpack_public_path__ + "img/icon-uploadFile.c25dc93b.png";